import styled from 'styled-components';
export const RewrdProgressTableContainer = styled.div`
  .bgcolorBlack {
    background-color: #000;
  }
  .minHeight300 {
    min-height: 300px;
  }

  .bgcolorWhite {
    background-color: #fff;
  }

  .progressTableRow {
    display: flex;
    border-bottom: 1px solid #e4e5f0;
    border-left: 1px solid #e4e5f0;
    background-color: #fff;
    padding: 0px 42px 0px 18px;
  }

  .progressTableRow:last-child {
    background-color: #fff;
    border-radius: 0px 0px 16px 0px;
    border-bottom: none;
  }

  .tableHeader {
    padding: 20px 32px 20px 18px;
    font-size: 18px;
    line-height: 24px;
    font-weight: 900;
    color: #fff;
  }

  .paddingL0 {
    padding-left: 0px;
  }

  .schemeTableData {
    background: #f9f7fe;
    padding: 0px 25px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    border-radius: 0px 0px 0px 16px;
  }

  .cashBack {
    display: flex;
    align-items: center;
    padding: 4px 12px 4px 4px;
    border-radius: 100px;
    margin-left: 8px;
  }

  .cashBack.Lock {
    border: 0.5px solid #e6e6e6;
    background: linear-gradient(289deg, #e6e6e6 12.53%, #c7c7c7 132.09%);
    box-shadow: -0.5px 0.5px 0px 0px #e5e5e5 inset, 0.4px -0.3px 0px 0px #858585 inset;
  }

  .cashBack.Unlock {
    border: 0.5px solid #ffeaa3;
    background: linear-gradient(289deg, #ffeaa3 12.53%, #dda43a 132.09%);
    box-shadow: -0.5px 0.5px 0px 0px #f2dfa7 inset, 0.4px -0.3px 0px 0px #c08000 inset;
  }

  .tableBrdr {
    border-radius: 16px;
    border: 1px solid #e4e5f0;
  }

  .trBrdrBottom:not(:last-child) {
    border-bottom: 1px solid #e4e5f0;
  }
  .makeFlex {
    display: flex;
  }

  .tHeaderRadius {
    border-radius: 16px 16px 0px 0px;
  }
  .blackBg {
    background-color: #000000;
  }
  .vrtlCenter {
    align-items: center;
  }
  .dirColumn {
    flex-direction: column;
  }

  .flexOne {
    flex: 1;
  }
  .appendBottom4 {
    margin-bottom: 4px;
  }
  .appendLeft4 {
    margin-left: 4px;
  }
  .appendRight12 {
    margin-right: 12px;
  }
  .appendLeft8 {
    margin-left: 8px;
  }
  .appendLeft2 {
    margin-left: 2px;
  }
  .appendLeft6 {
    margin-left: 6px;
  }
  .appendLeft20 {
    margin-left: 20px;
  }
  .appendTop10 {
    margin-top: 10px;
  }
  .font14 {
    font-size: 14px;
  }
  .font12 {
    font-size: 12px;
  }
  .font18 {
    font-size: 18px;
  }
  .font16 {
    font-size: 16px;
  }
  .lineHeight16 {
    line-height: 16px !important;
  }
  .lineHeight28 {
    line-height: 28px !important;
  }
  .lineHeight24 {
    line-height: 24px !important;
  }
  .latoBlack {
    font-weight: 900;
  }
  .latoBold {
    font-weight: 700;
  }
  .lineHeight20 {
    line-height: 20px !important;
  }
  .tertiaryTxt {
    color: #757575;
  }
  .secondaryTxt {
    color: #4a4a4a;
  }

  .td1 {
    padding: 24px 0px 24px 0px;
  }

  .td3 {
    /* padding: 42px 42px 24px 50px; */
    display: flex;
    width: 215px;
    flex-shrink: 0;
    align-items: center;
    margin-left: auto;
    justify-content: flex-start;
  }

  .width174 {
    width: 174px;
  }
  .width418 {
    min-width: 418px;
  }
  .width332 {
    width: 332px;
  }
  .width430 {
    width: 430px;
  }
  .width215 {
    min-width: 215px;
  }

  .makeRelative {
    position: relative;
  }
  .primaryTxtWhite {
    color: #ffffff;
  }
  .appendBottom22 {
    margin-bottom: 22px;
  }
  .mypTblBackdrop {
    height: 275px;
    background-color: rgba(0, 0, 0, 0.8);
    border-radius: 16px;
    position: absolute;
    top: 0;
    left: 0;
    width: 1200px;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .backdropMyp {
    padding: 10px 16px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 900;
    color: #ffffff;
    border-radius: 8px;
    border: none;
    text-transform: uppercase;
    background: linear-gradient(94deg, #53b2fe 0%, #065af3 100%);
    cursor: pointer;
  }
  .mypBrownText {
    color: #a5572a;
  }
`;
